import React, { useEffect, useState } from 'react';
import { PlusIcon, XIcon } from 'lucide-react';
import { useAppState } from '../../contexts/AppStateContext';
import { DEMO_DATE } from '../../data/demo';
import { schoolKindLabels } from '../../data/labels';
import { SchoolKind } from '../../types/shared';
import { addDays } from '../../utils/time';
import { Sheet } from '../ui/Sheet';
import { Button } from '../ui/Button';
import { Chip, Field } from '../ui/Form';
export function AddSchoolSheet({
  open,
  onClose
}: {
  open: boolean;
  onClose: () => void;
}) {
  const {
    activeMembers,
    viewer,
    isAdmin,
    addSchoolItem
  } = useAppState();
  const kids = activeMembers.filter(m => m.role === 'otrok');
  const [memberId, setMemberId] = useState(viewer.id);
  const [kind, setKind] = useState<SchoolKind>('test');
  const [title, setTitle] = useState('');
  const [date, setDate] = useState(addDays(DEMO_DATE, 4));
  const [blocks, setBlocks] = useState<{
    date: string;
    minutes: number;
  }[]>([]);
  useEffect(() => {
    if (!open) return;
    setMemberId(isAdmin ? kids[0]?.id ?? viewer.id : viewer.id);
    setKind('test');
    setTitle('');
    setDate(addDays(DEMO_DATE, 4));
    setBlocks([{
      date: DEMO_DATE,
      minutes: 30
    }]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open]);
  const withBlocks = kind === 'test' || kind === 'sprasevanje';
  return <Sheet open={open} onClose={onClose} title="Nova šolska obveznost" subtitle="Test ima datum, priprava pa lahko več učnih blokov." footer={<Button className="w-full" disabled={!title.trim()} onClick={() => {
    addSchoolItem({
      memberId,
      kind,
      title: title.trim(),
      date,
      blocks: withBlocks ? blocks.filter(b => b.minutes > 0) : []
    });
    onClose();
  }} data-id="element-36" data-mp="2noqjl5582htg">
          Shrani
        </Button>} data-id="element-35" data-mp="2xi7bg3lstmuh">
      <div className="space-y-4" data-id="element-37" data-mp="24rfjxjfohmdh">
        {isAdmin && <div className="flex flex-wrap gap-2" data-id="element-38" data-mp="24rxp55kbjaxj">
            {kids.map(m => <Chip key={m.id} color={m.color} active={memberId === m.id} onClick={() => setMemberId(m.id)} data-id="element-39" data-mp="1v2s341exx6i1">
                {m.name}
              </Chip>)}
          </div>}
        <div className="flex flex-wrap gap-2" data-id="element-40" data-mp="1l6f8n1bkmom8">
          {(Object.keys(schoolKindLabels) as SchoolKind[]).map(k => <Chip key={k} active={kind === k} onClick={() => setKind(k)} data-id="element-41" data-mp="1q58qf5xw51s7">
              {schoolKindLabels[k]}
            </Chip>)}
        </div>
        <Field label="Naziv" data-id="element-42" data-mp="2it4ks3zzmhlt">{id => <input id={id} className="field" value={title} onChange={e => setTitle(e.target.value)} placeholder="npr. Fizika – test" data-id="element-43" data-mp="2iscoss2hahv0" />}</Field>
        <Field label={withBlocks ? 'Datum testa / spraševanja' : 'Rok'} data-id="element-44" data-mp="242nkwp303zr1">{id => <input id={id} type="date" className="field" value={date} onChange={e => setDate(e.target.value)} data-id="element-45" data-mp="29205f36eguqg" />}</Field>
        {withBlocks && <div data-id="element-46" data-mp="31jlyp2g5v8n4">
            <p className="mb-1.5 text-sm font-bold" data-id="element-47" data-mp="31kf685my226b">Pripravljalni učni bloki</p>
            <ul className="space-y-2" data-id="element-48" data-mp="q4wsfsg9jh2k">
              {blocks.map((b, i) => <li key={i} className="flex items-center gap-2" data-id="element-49" data-mp="q2k48xjwwah2" data-mpi={i}>
                  <input type="date" aria-label={`Datum bloka ${i + 1}`} className="field" value={b.date} max={date} onChange={e => setBlocks(bs => bs.map((x, j) => j === i ? {
              ...x,
              date: e.target.value
            } : x))} data-id="element-50" data-mp="l50rk22v45r8" />
                  <input type="number" aria-label={`Minute bloka ${i + 1}`} className="field w-24" min={5} value={b.minutes} onChange={e => setBlocks(bs => bs.map((x, j) => j === i ? {
              ...x,
              minutes: Number(e.target.value)
            } : x))} data-id="element-51" data-mp="uwetshm77jo2" />
                  <span className="text-sm text-muted" data-id="element-52" data-mp="g78nyasuuv77">min</span>
                  <button type="button" aria-label="Odstrani blok" onClick={() => setBlocks(bs => bs.filter((_, j) => j !== i))} className="grid h-10 w-10 place-items-center rounded-xl text-muted hover:bg-canvas" data-id="element-53" data-mp="g4mhyflm4nr3">
                    <XIcon className="h-4 w-4" data-id="element-54" data-mp="1nkappk3y17js" />
                  </button>
                </li>)}
            </ul>
            <Button size="sm" variant="ghost" className="mt-2" onClick={() => setBlocks(bs => [...bs, {
          date: addDays(bs[bs.length - 1]?.date ?? DEMO_DATE, 1),
          minutes: 30
        }])} data-id="element-55" data-mp="2iv8x6i8o2541">
              <PlusIcon className="h-4 w-4" aria-hidden="true" data-id="element-56" data-mp="2rvf4fmdru8ur" /> Učni blok
            </Button>
            <p className="mt-1 text-xs text-muted" data-id="element-57" data-mp="2wtythvnnw0rc">Bloki se pojavijo na Danes v izbrane dni. Nagrajujemo dogovorjeni trud, ne ocen.</p>
          </div>}
      </div>
    </Sheet>;
}